<template><component v-if="document" :is="isPdf(document) || document.preview_route ? 'PdfViewer' : 'DocumentPreview'" ref="viewer" :key="sequence" :document="document" @close="document = null" /></template>
<script>
import PdfViewer from './pdf-viewer.vue';
import DocumentPreview from './document-preview.vue';
import { isPdf } from './pdf-runtime';
export default {
    components: { PdfViewer, DocumentPreview },
    data() { return { document: null, sequence: 0 }; },
    mounted() { window.addEventListener('c2c:open-pdf', this.open); },
    beforeDestroy() { window.removeEventListener('c2c:open-pdf', this.open); },
    methods: {
        isPdf,
        open(event) {
            if (this.$refs.viewer && !this.$refs.viewer.canDiscard()) return;
            this.document = event.detail; this.sequence++;
        },
    },
};
</script>
